module.exports = "<img class=\"swiss-logo\" src=\"/images/dashboard/swiss_logo.svg\" alt=\"SWISS\">\n"